import {
  css,
  FlattenSimpleInterpolation
} from "styled-components";

import { PromotionTemplate } from "src/modules/promotions/api/promotions.api";
import {
  getTemplateBannerAspect,
  aspectRatioToInteger
} from "src/modules/promotions/utils";

/**
 * Sets the promotion banners image dimensions and position for the given template
 */
export const setTemplateBannerImageDimensionsCSS = (template: PromotionTemplate, imageHeightRem: number): FlattenSimpleInterpolation => {
  const aspect = getTemplateBannerAspect(template);
  const width = imageHeightRem * aspectRatioToInteger(aspect);
  const height = imageHeightRem;
  let top: number | "auto" = 0;
  let bottom: number | "auto" = "auto";
  let left: number | "auto" = 0;
  let right: number | "auto" = "auto";

  // Set the position of the banner depending on the template
  switch (template) {
    default:
    case PromotionTemplate.Small:
      top = 0;
      bottom = "auto";
      left = 0;
      right = "auto";
      break;

    case PromotionTemplate.Large:
      top = 0;
      bottom = "auto";
      left = "auto";
      right = 0;
      break;
  }

  return css`
    top: ${top};
    bottom: ${bottom};
    left: ${left};
    right: ${right};
    width: ${`${width}rem`};
    height: ${`${height}rem`};
  `;
};
